// Pinned stop-scroller.
//  • Desktop (≥768px): scroll progress through the tall outer maps to the active step.
//  • Mobile (≤767px): controlled by the "Mobile step navigation" setting (data-ss-mobile):
//      - "scroll" (default): same pinned scroll behaviour as desktop.
//      - "swipe": horizontal drag changes the step — drag LEFT = next, RIGHT = prev.
//        Uses Pointer Events, so it works with both touch swipe and mouse drag.
//        The step pips double as clickable dots — tap/click one to jump to that step.
// Panels crossfade via the .is-active class. Mode re-binds live when crossing the breakpoint.
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 767px)');

  document.querySelectorAll('[data-sticky-steps]').forEach(function (outer) {
    var pin = outer.querySelector('.sticky-steps__pin');
    var steps = Array.prototype.slice.call(outer.querySelectorAll('[data-ss-panel]'));
    var counter = outer.querySelector('[data-ss-counter]');
    var hint = outer.querySelector('.sticky-steps__hint');
    if (!pin || !steps.length) return;

    var total = steps.length;
    var current = -1;

    function setStep(idx) {
      idx = Math.max(0, Math.min(total - 1, idx));
      if (idx === current) return;
      current = idx;
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + total;
    }

    // swipe drives steps only on mobile AND when the setting is "swipe"
    function swipeMode() {
      return mq.matches && outer.getAttribute('data-ss-mobile') === 'swipe';
    }

    // ── scroll progress drives the step (desktop, and mobile "scroll" mode) ──
    function onScroll() {
      var rect = outer.getBoundingClientRect();
      var available = rect.height - window.innerHeight;
      if (available <= 0) { setStep(0); return; }
      var progress = Math.max(0, Math.min(1 - 1e-9, -rect.top / available));
      setStep(Math.min(total - 1, Math.floor(progress * total)));
    }

    // ── horizontal drag drives the step (mobile "swipe" mode) ──
    // Pointer Events unify touch swipe + mouse drag + pen. We only need the start
    // and end positions; pointerup is bound on window so a mouse released outside
    // the pin still completes the gesture.
    var startX = 0, startY = 0, tracking = false, activeId = null;
    var SWIPE_MIN = 45; // px of horizontal travel needed to change step

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return; // left button only
      startX = e.clientX; startY = e.clientY; tracking = true; activeId = e.pointerId;
    }
    function onPointerUp(e) {
      if (!tracking || e.pointerId !== activeId) return;
      tracking = false;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      // only a clearly-horizontal gesture counts (vertical is left to page scroll)
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_MIN) {
        if (dx < 0) setStep(current + 1); // drag left  → next
        else setStep(current - 1);        // drag right → prev
      }
    }
    function onPointerCancel() { tracking = false; }

    // ── peeking carousel drives the step (mobile "slider" mode) ──
    // The panels are laid out in a scroll-snap row (CSS). Touch scrolls natively
    // (low-effort flick-to-advance); mouse gets drag-to-scroll with an eased glide.
    // A scroll listener keeps the counter/active state synced to the centred panel.
    function sliderMode() {
      return mq.matches && outer.getAttribute('data-ss-mobile') === 'slider';
    }
    function nearestIndex() {
      var center = pin.scrollLeft + pin.clientWidth / 2;
      var best = 0, bestD = Infinity;
      steps.forEach(function (s, i) {
        var d = Math.abs((s.offsetLeft + s.offsetWidth / 2) - center);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }
    function centerLeft(idx) {
      var p = steps[idx];
      return p ? p.offsetLeft - (pin.clientWidth - p.offsetWidth) / 2 : 0;
    }
    function jumpToIndex(idx) {
      idx = Math.max(0, Math.min(total - 1, idx));
      pin.scrollLeft = centerLeft(idx);
      setStep(idx);
    }
    var slRaf = null;
    function glideToIndex(idx) {
      idx = Math.max(0, Math.min(total - 1, idx));
      if (slRaf) cancelAnimationFrame(slRaf);
      pin.classList.add('is-sliding'); // snap off during the animation
      var startL = pin.scrollLeft, dist = centerLeft(idx) - startL, t0 = null;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / 380);
        pin.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3)); // easeOutCubic
        if (p < 1) { slRaf = requestAnimationFrame(frame); }
        else { slRaf = null; pin.classList.remove('is-sliding'); setStep(idx); }
      }
      slRaf = requestAnimationFrame(frame);
    }
    var slScrollRaf = null;
    function onSliderScroll() {
      if (slScrollRaf) return;
      slScrollRaf = requestAnimationFrame(function () { setStep(nearestIndex()); slScrollRaf = null; });
    }
    // mouse drag-to-scroll (touch uses native scrolling + snap)
    var slDown = false, slDragged = false, slStartX = 0, slStartLeft = 0,
      slStartIdx = 0, slLastX = 0, slLastT = 0, slV = 0;
    function onSlDown(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (slRaf) { cancelAnimationFrame(slRaf); slRaf = null; }
      slDown = true; slDragged = false;
      slStartX = e.clientX; slStartLeft = pin.scrollLeft; slStartIdx = nearestIndex();
      slLastX = e.clientX; slLastT = Date.now(); slV = 0;
    }
    function onSlMove(e) {
      if (!slDown) return;
      var dx = e.clientX - slStartX;
      if (!slDragged && Math.abs(dx) > 4) {
        slDragged = true;
        pin.classList.add('is-sliding');
        try { pin.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (slDragged) {
        pin.scrollLeft = slStartLeft - dx;
        var now = Date.now(), dt = now - slLastT;
        if (dt > 0) slV = (e.clientX - slLastX) / dt;
        slLastX = e.clientX; slLastT = now;
      }
    }
    function onSlUp() {
      if (!slDown) return;
      slDown = false;
      if (!slDragged) return;
      // low-effort flick: a small release velocity is enough to advance one step,
      // otherwise settle on whichever step is nearest the centre.
      var idx;
      if (slV < -0.25) idx = slStartIdx + 1;
      else if (slV > 0.25) idx = slStartIdx - 1;
      else idx = nearestIndex();
      glideToIndex(idx);
    }
    function preventDrag(e) { e.preventDefault(); }

    // ── mode binding ──
    var swipeBound = false, scrollBound = false, sliderBound = false;

    function bindSwipe() {
      if (swipeBound) return;
      pin.addEventListener('pointerdown', onPointerDown);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerCancel);
      swipeBound = true;
    }
    function unbindSwipe() {
      if (!swipeBound) return;
      pin.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('pointerup', onPointerUp);
      window.removeEventListener('pointercancel', onPointerCancel);
      swipeBound = false;
    }
    function bindScroll() {
      if (scrollBound) return;
      window.addEventListener('scroll', onScroll, { passive: true });
      scrollBound = true;
    }
    function unbindScroll() {
      if (!scrollBound) return;
      window.removeEventListener('scroll', onScroll);
      scrollBound = false;
    }
    function bindSlider() {
      if (sliderBound) return;
      pin.addEventListener('scroll', onSliderScroll, { passive: true });
      pin.addEventListener('pointerdown', onSlDown);
      window.addEventListener('pointermove', onSlMove);
      window.addEventListener('pointerup', onSlUp);
      window.addEventListener('pointercancel', onSlUp);
      pin.addEventListener('dragstart', preventDrag);
      sliderBound = true;
      requestAnimationFrame(function () { jumpToIndex(current < 0 ? 0 : current); });
    }
    function unbindSlider() {
      if (!sliderBound) return;
      pin.removeEventListener('scroll', onSliderScroll);
      pin.removeEventListener('pointerdown', onSlDown);
      window.removeEventListener('pointermove', onSlMove);
      window.removeEventListener('pointerup', onSlUp);
      window.removeEventListener('pointercancel', onSlUp);
      pin.removeEventListener('dragstart', preventDrag);
      pin.classList.remove('is-sliding');
      sliderBound = false;
    }

    function applyMode() {
      if (sliderMode()) {
        if (hint) hint.textContent = 'swipe to explore';
        unbindScroll();
        unbindSwipe();
        bindSlider();
      } else if (swipeMode()) {
        if (hint) hint.textContent = 'swipe to continue';
        unbindScroll();
        unbindSlider();
        bindSwipe();
      } else {
        if (hint) hint.textContent = 'scroll to continue';
        unbindSwipe();
        unbindSlider();
        bindScroll();
        onScroll();
      }
    }

    // ── clickable step pips (mobile "swipe" mode) ──
    // Every panel renders its own pip row; wire each pip to jump to its index.
    // Gated at click-time by swipeMode(), so pips stay inert on desktop and in
    // scroll mode. A tap/click has ~0 travel, so it never trips the drag handler.
    steps.forEach(function (panel) {
      var pips = panel.querySelectorAll('.sticky-steps__pip');
      Array.prototype.forEach.call(pips, function (pip, i) {
        pip.addEventListener('click', function () {
          if (!swipeMode()) return;
          setStep(i);
        });
      });
    });

    setStep(0);
    applyMode();
    window.addEventListener('resize', function () {
      if (sliderMode()) jumpToIndex(current < 0 ? 0 : current);
      else if (!swipeMode()) onScroll();
    });
    if (mq.addEventListener) mq.addEventListener('change', applyMode);
    else mq.addListener(applyMode); // Safari < 14
  });
})();
